import VueRouter from "vue-router"

import NotFound from "@/pages/not-found.vue"
import Login from "@/pages/login.vue"
import Layout from "@/pages/layout.vue"
import Home from "@/pages/home/index.vue"
import NotesHistoric from "@/pages/home/notes-historic.vue"
import Profile from "@/pages/profile/form.vue"

import routers from "@/pages/routers"
import AppBrowser from "./utils/browser"

const catchNotFound = { path: "*", redirect: "/notfound" }
const notFoundRoute = { path: "/notfound", component: NotFound }
const loginRoute = { path: "/login", component: Login }

let layoutChildRoutes = [
  { path: "", component: Home },
  { path: "/notes-historic", component: NotesHistoric },
  { path: "/profile", component: Profile },
]

routers.forEach((router) => router(layoutChildRoutes))

const layoutRoutes = { path: "", component: Layout, children: layoutChildRoutes }

const router = new VueRouter({
  routes: [
    loginRoute,
    layoutRoutes,
    notFoundRoute,
    catchNotFound,
  ],
  mode: "history"
})

router.afterEach(() => AppBrowser.scrollTop())

export default router
